<template>
  <el-dialog
    title="设置数据权限"
    width="80%"
    :close-on-click-modal="false"
    :visible.sync="view.visible">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item label="编码:">
        <el-input size="small" v-model="dataForm.key" placeholder="编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="名称:">
        <el-input size="small" v-model="dataForm.key" placeholder="名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="getDataList()" icon="el-icon-search">
          查询
        </el-button>
      </el-form-item>
    </el-form>
    <el-table :data="dataList" border class="eltable" v-loading="dataListLoading" size="small" :height=documentClientHeight
              @selection-change="selectionChangeHandle" style="width: 100%;">
      <el-table-column type="selection" header-align="center" align="center" width="50">
      </el-table-column>
      <el-table-column prop="roleId" header-align="center" align="center" width="50" v-if="false" label="ID">
      </el-table-column>
      <el-table-column type="index" label="序号" header-align="left" align="left" width="50">
      </el-table-column>
      <el-table-column prop="roleName" header-align="left" align="left" width="150" label="岗位名称">
      </el-table-column>
      <el-table-column prop="code" header-align="left" align="left" width="150" label="岗位编码">
      </el-table-column>
      <el-table-column prop="tenant" header-align="left" align="left" min-width="100" show-overflow-tooltip=true
                        label="租户">
      </el-table-column>
      <el-table-column prop="remark" header-align="left" align="left" :show-overflow-tooltip="true" label="组织">
      </el-table-column>
      <el-table-column header-align="left" align="left" min-width="180" label="操作">
        <template slot-scope="scope">
          <el-radio-group v-model="scope.row.authoritytype">
            <el-radio label="ALL">全部</el-radio>
            <el-radio label="ORG">组织</el-radio>
            <el-radio label="PRE">个人</el-radio>
          </el-radio-group>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="view.visible = false">取消
      </el-button>
      <el-button size="small" type="primary" @click="dataFormSubmit()">确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        dataList: [],
        view: {
          visible: false,
          conheight: {
            height: this.$store.state.common.documentClientDefaultHeight * 0.9 - 410 + 'px',
            'overflow-y': 'auto'
          },
        },
        viewData: {
        },
        dataForm: {
          id: 0,
          roleName: '',
          mtp: '',
          remark: '',
          tenant: '',
          mtpName: ''
        },
        dataRule: {
          roleName: [
            { required: true, message: '角色名称不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.view.visible = true
        this.dataList = [{
          roleName: '管理员',
          code: 'ADMIN'
        }]
        //TODO
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            //TODO
          }
        })
      }
    }
  }
</script>
